import dateFormat from 'dateformat';
import { getOffset } from 'client/site-modules/shared/utils/time-util';
import { time12To24HoursFormat } from 'client/utils/time-format';

/**
 * Checks if dealer is opened considering dealer's timezone and DST.
 * @param {string} dst - 1 if dst is observed, 0 if not
 * @param {string} timeZone
 * @param {object} workHours
 * @param {string} currentDay
 * @returns {boolean}
 */
export function isDealerOpen({ dst, timeZone }, workHours, currentDay) {
  const currentTime = Date.now();
  const offset = getOffset(timeZone, dst);
  const currentDate = dateFormat(currentTime, 'yyyy/mm/dd');
  const dealerWorkingDay = workHours[currentDay.toLowerCase()];

  if (!dealerWorkingDay) {
    return false; // the dealership is closed if there is no data for a specific day
  }

  const dealerWorkingTimeOpen = time12To24HoursFormat(dealerWorkingDay.open);
  const dealerWorkingTimeClose = time12To24HoursFormat(dealerWorkingDay.close);
  const openTime = new Date(`${currentDate} ${dealerWorkingTimeOpen} ${offset}`);
  const closeTime = new Date(`${currentDate} ${dealerWorkingTimeClose} ${offset}`);

  return currentTime >= openTime.getTime() && currentTime < closeTime.getTime();
}
